/**
 * Component Registry for The Dorset
 * 
 * Inherits from @vibesites-price-brothers/theme-rise and allows property-specific overrides.
 */

import type { ComponentRegistry } from '@vibesites/runtime';
import { registry as parentRegistry } from '@vibesites-price-brothers/theme-rise/registry';
import ContactForm from './components/ContactForm';
import SisterProperties from './components/SisterProperties';
import { GallerySeparator } from './components/GallerySeparator';
import ScheduleTourForm from './components/ScheduleTourForm';
import { TabbedCallouts } from './components/TabbedCallouts';
import FaqList from './components/FaqList';

/**
 * Property-specific component overrides.
 */
const propertyOverrides: Partial<ComponentRegistry> = {
  ContactForm,
  SisterProperties,
  GallerySeparator,
  ScheduleTourForm,
  TabbedCallouts,
  FaqList,
};

/**
 * Final merged registry for this property.
 * Inherits all components from the parent theme, with property overrides.
 */
export const registry: ComponentRegistry = {
  ...parentRegistry,
  ...propertyOverrides,
};

export default registry;
